import React from 'react';
import { WarningFilled } from '@carbon/react/icons';
import styles from './well-survey-structure-grid-empty-state.module.scss';

const WellSurveyAndStructureGridEmptyState: React.FC = () => (
  <div className={styles.emptyStateContainer}>
    <div className={styles.iconWrapper}>
      <WarningFilled className={styles.icon} />
    </div>
    <div className={styles.textWrapper}>
      <div className={styles.title}>
        No Well Surveys or Structure Grids available
      </div>
      <div className={styles.subtitle}>
        Please modify your search area or well selection.
      </div>
    </div>
  </div>
);

export default WellSurveyAndStructureGridEmptyState;
